import { Attributes } from '@leverege/ui-attributes';
import AttributeSortModel from "../../../filters/sort/AttributeSortModel.js";
export default {
  type: 'molten.SortModel',
  convert: (sortModel, context) => {
    const {
      objectType
    } = context;
    const fields = AttributeSortModel.getFields(sortModel);
    const sort = fields.map(field => {
      const attribute = Attributes.getAttribute(field.attrName, objectType);
      if (!attribute) {
        return null;
      }
      return {
        field: attribute.blueprint?.field,
        missing: field.order === 'asc' ? '_first' : '_last',
        order: field.order
      };
    }).filter(field => field != null);
    if (sort.length > 0) {
      return sort;
    }
    return null;
  }
};